// Define an object DS_VERSIONS to represent different design system versions.
export const DS_VERSIONS = {
  default: 'default'
};

// Freeze the DS_VERSIONS object to make it immutable.
Object.freeze(DS_VERSIONS);
